import join from 'url-join';

import { asyncAction, createAction, http } from '../../util/index';
import { showToast } from '../../components/toast/actions';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

const api2 = join(import.meta.env.VITE_API2_URL, 'v1');

export const addReturnsFilter = createAction('ADD_RETURNS_FILTER');
export const removeReturnsFilter = createAction('REMOVE_RETURNS_FILTER');
export const clearReturnsFilters = createAction('CLEAR_RETURNS_FILTERS');
export const clearReturnsFilter = createAction('CLEAR_RETURNS_FILTER');
export const updateReturnsDateRange = createAction('UPDATE_RETURNS_DATE_RANGE');
export const setReturnsFilters = createAction('SET_RETURNS_FILTERS');

export const updateReturnsSortBy = createAction('UPDATE_RETURNS_SORT_BY');
export const clearReturnsSortBy = createAction('CLEAR_RETURNS_SORT_BY');
export const setReturnsListType = createAction('SET_RETURNS_LIST_TYPE');

export const setNavNewReturn = createAction('BEGIN_NEW_RETURN_CLICKED');

export const setSearchValues = createAction('SET_SEARCH_VALUES');
export const setRequestAnchor = createAction('SET_REQUEST_ANCHOR');

export const requestReturns = asyncAction({
  baseName: 'REQUEST_RETURNS',
  action: action => ({ filter, sort, count, anchor }) => dispatch => {
    dispatch(action.start());
    return http
      .get(join(api2, `/returns?${filter}${sort}&count=${count}&anchor=${anchor}`))
      .then(({ data: response }) => dispatch(action.success({ ...response, isInitialCall: anchor === 0 })))
      .catch(error => dispatch(action.error({ error })));
  }
});

export const deleteReturn = asyncAction({
  baseName: 'DELETE_RETURN',
  action: action => ({ returnId }) => dispatch => {
    dispatch(action.start(returnId));
    return http
      .delete(join(api2, `/returns/${returnId}`))
      .then(() => {
        dispatch(
          showToast({
            message: new TranslatedCopy({ id: 'returnStatus.delete.success' }).toString(),
            type: 'success'
          })
        );
        return dispatch(action.success({ returnId }));
      })
      .catch(error => {
        dispatch(
          showToast({
            message: new TranslatedCopy({ id: 'global.toast.systemError' }).toString(),
            type: 'error',
            error
          })
        );
        return dispatch(action.error(error?.message));
      });
  }
});
